module.exports = {
          srcSet: __webpack_public_path__ + "public/images/2ddee426a1672b1fb4345f11b6d41ea7-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/2ddee426a1672b1fb4345f11b6d41ea7-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/2ddee426a1672b1fb4345f11b6d41ea7-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/2ddee426a1672b1fb4345f11b6d41ea7-1774.webp"},
          
          width: 1774,
          height: 887
        }